// Demo selections have to survive the navigation to the page that runs the demo, which leaves the
// SPA and so drops in-memory state. Session storage scopes them to the presenter's tab and clears
// itself when the tab closes, so a demo can never leak into a later session.
export const DEMO_STORAGE_KEY = 'goalbook.customizationDemo.selections'

export const readStoredSelections = () => {
  try {
    const stored = window.sessionStorage.getItem(DEMO_STORAGE_KEY)
    const parsed = stored ? JSON.parse(stored) : null
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (error) {
    return {}
  }
}

export const writeStoredSelections = (selections) => {
  try {
    window.sessionStorage.setItem(DEMO_STORAGE_KEY, JSON.stringify(selections))
  } catch (error) {
    // A presenter with storage blocked still gets a working picker, just not one that
    // survives the hop to the page being demoed.
  }
}
